import { Locale } from 'date-fns';
import { enUS, ru, uk } from 'date-fns/locale';
import { InterfaceLanguage } from 'types/enums';

export const getLocaleFromLang = (lang: InterfaceLanguage): Locale => {
  const locales = {
    [InterfaceLanguage.English]: enUS,
    [InterfaceLanguage.Russian]: ru,
    [InterfaceLanguage.Ukranian]: uk,
  };

  return locales[lang];
};
